import { HttpMethods, RequestPerformer } from '@/api/api-requests-factory';
import { Ref } from 'vue';
import UploadLimitExceptionsRequest from './upload-limit-exceptions.request';

export class LimitExceptionsUploadApiResources {
  public constructor(
    private readonly requestPerformer: RequestPerformer,
    private readonly multibrandApiUrl: Ref<string>,
  ) {}

  public get uploadLimitExceptionsRequest(): UploadLimitExceptionsRequest {
    return new UploadLimitExceptionsRequest(
      this.requestPerformer,
      `${this.multibrandApiUrl.value}/bulkUpdateExtendedLimitsByExcelFile`,
      HttpMethods.POST,
    );
  }
}
